import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rxnt-inline-spinner',
  templateUrl: './rxnt-inline-spinner.component.html',
  styleUrl: './rxnt-inline-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RxntInlineSpinnerComponent {
  @Input() show: boolean = true;
}
